import React from 'react'
import Header from './Header'
import Footer from './Footer'
import t from './translate'
import Container from 'react-bootstrap/Container'

export default function Layout ({ homeUrl, children }) {
  return (
    <>
      <Header homeUrl={homeUrl}/>
      <div className={'banner'}>
        <Container>
          <h1>{t('title')}</h1>
        </Container>
      </div>
      <Container className={'intro'}>
        <h2>{t('intro.title')}</h2>
        <p dangerouslySetInnerHTML={{ __html: t('intro.text') }}></p>
      </Container>
      <Container>
        {children}
      </Container>
      <Footer/>
    </>
  )
}
